import t from"./utils/build-product.js";import i from"./utils/tikTokTrack.js";const o=i((i,{eventId:o,value:d}={})=>{(null==d?void 0:d.item)&&i("AddToCart",t(null==d?void 0:d.item),{event_id:o})});export{o as default};
